// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container {
  max-width: 800px;
  margin: 0 auto;
}

.note {
  color: #666;
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
}

.input-group {
  display: flex;
  align-items: center;
}

.input-group-prepend,
.input-group-append {
  background-color: #e9ecef;
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.input-group-prepend {
  border-right: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group-append {
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group .form-control {
  border-radius: 0;
}

.employee-section {
  background-color: #f8f9fa;
}

.results-section {
  background-color: #fff;
}

.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 20px auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.calculator-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.calculator-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.calculator-header h1 {
  margin: 0;
  font-size: 24px;
}

.help-button {
  background: none;
  border: none;
  color: #4444e4;
  cursor: pointer;
}

.employees-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #f0f0f0;
  margin: 20px 0;
}

.add-button {
  background-color: #4444e4;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.employee-form {
  background-color: #f8f8f8;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.input-group {
  display: flex;
  align-items: center;
}

.input-group input {
  flex: 1 1;
  margin: 0 5px;
}

.button-group {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.saved-employees table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.saved-employees th,
.saved-employees td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.employee-row {
  cursor: pointer;
}

.employee-details {
  padding: 15px;
  background-color: #f8f8f8;
}

.actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.expand-button {
  background: none;
  border: none;
  cursor: pointer;
  color: #4444e4;
}

.calculate-button {
  width: 100%;
  padding: 10px;
  background-color: #4444e4;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;
}

.calculate-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.results-container {
  margin-top: 30px;
  background: white;
  border-radius: 4px;
  overflow: hidden;
}

.results-title {
  font-size: 24px;
  margin-bottom: 20px;
  border-bottom: 1px solid #000;
  padding-bottom: 8px;
  color: #333;
}

.fund-header {
  background: #e9ecef;
  padding: 12px;
  font-weight: normal;
  margin: 20px 0 0 0;
}

.results-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.results-table th,
.results-table td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #dee2e6;
}

.results-table th {
  font-weight: normal;
  color: #333;
}

.total-row {
  font-weight: bold;
  background: #f9f9f9;
  border-top: 1px solid #dee2e6;
}

.total-row td {
  padding-top: 12px;
  border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./src/components/agent/superguaranteecalculator.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":[".form-container {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.note {\n  color: #666;\n  font-size: 0.9rem;\n  margin-bottom: 1.5rem;\n}\n\n.input-group {\n  display: flex;\n  align-items: center;\n}\n\n.input-group-prepend,\n.input-group-append {\n  background-color: #e9ecef;\n  padding: 0.375rem 0.75rem;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n\n.input-group-prepend {\n  border-right: none;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group-append {\n  border-left: none;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.input-group .form-control {\n  border-radius: 0;\n}\n\n.employee-section {\n  background-color: #f8f9fa;\n}\n\n.results-section {\n  background-color: #fff;\n}\n\n.loader {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #007bff;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin: 20px auto;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.calculator-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.calculator-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.calculator-header h1 {\n  margin: 0;\n  font-size: 24px;\n}\n\n.help-button {\n  background: none;\n  border: none;\n  color: #4444e4;\n  cursor: pointer;\n}\n\n.employees-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  background-color: #f0f0f0;\n  margin: 20px 0;\n}\n\n.add-button {\n  background-color: #4444e4;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.employee-form {\n  background-color: #f8f8f8;\n  padding: 20px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.input-group {\n  display: flex;\n  align-items: center;\n}\n\n.input-group input {\n  flex: 1;\n  margin: 0 5px;\n}\n\n.button-group {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n}\n\n.saved-employees table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 20px;\n}\n\n.saved-employees th,\n.saved-employees td {\n  padding: 10px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\n.employee-row {\n  cursor: pointer;\n}\n\n.employee-details {\n  padding: 15px;\n  background-color: #f8f8f8;\n}\n\n.actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.expand-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #4444e4;\n}\n\n.calculate-button {\n  width: 100%;\n  padding: 10px;\n  background-color: #4444e4;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 20px;\n}\n\n.calculate-button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.results-container {\n  margin-top: 30px;\n  background: white;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.results-title {\n  font-size: 24px;\n  margin-bottom: 20px;\n  border-bottom: 1px solid #000;\n  padding-bottom: 8px;\n  color: #333;\n}\n\n.fund-header {\n  background: #e9ecef;\n  padding: 12px;\n  font-weight: normal;\n  margin: 20px 0 0 0;\n}\n\n.results-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 20px;\n}\n\n.results-table th,\n.results-table td {\n  padding: 8px;\n  text-align: left;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.results-table th {\n  font-weight: normal;\n  color: #333;\n}\n\n.total-row {\n  font-weight: bold;\n  background: #f9f9f9;\n  border-top: 1px solid #dee2e6;\n}\n\n.total-row td {\n  padding-top: 12px;\n  border-bottom: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
